/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import _, { values } from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import custom component
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { defaultSelectBy, InvNumSelectBy } from './ConstantData';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  TableHeaderForManufacturer,
  TableHeaderForTempLetter,
} from './gridComponents/tableHead';
import CheckBoxComponent from '../../../../SharedModules/CheckBox/CheckBox';
import {
  radioGroupLabelNameSelectedBy,
  viewPortHeight_355,
  radioGroupLabelNamePlan,
  rebateProgramLabelName,
  SUCCESS_MSG,
  STATUS_MSG,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchSearchTabData,
  handleErrorMessages,
  getCheckBoxValue,
  getCommonDropdownList,
  getManufacturerList,
  setMfgSelected,
  getTemplateType,
  getTemplateName,
  getTempTableData,
  getRebateFromInvoice,
  resetRedux,
  dispatchManufacturerData,
  dispatchTempTableData,
  dispatchTemplateNameList,
  setCreateTemplateExtraState,
  fetchCreateLetterDetailData,
  updateCreateLetterSaveApi,
  updateCreateLetterDetail,
  updateInvoiceDetailsByInvoiceNum,
  getInvoiceDetailsByInvoiceNum,
  updateCreateLetterDetailData,
  dispatchFirstError,
} from '../store/Actions';

const DisplayLetterSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  /* dispatch function */

  const searchTabData = useSelector(
    (state) => state.sharedState?.LetterReducer?.searchTabData
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.LetterReducer.checkbox
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const mfgSelected = useSelector(
    (state) => state.sharedState?.LetterReducer?.mfgSelected
  );

  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.LetterReducer?.errorMessagesInRedux
  );

  const fetchManufacturerList = useSelector(
    (state) => state.sharedState.LetterReducer.manufacturerList
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const templateTypeList = useSelector(
    (state) => state.sharedState.LetterReducer.templateTypeList
  );

  const templateNameList = useSelector(
    (state) => state.sharedState.LetterReducer.templateNameList
  );

  const tempLetterTableData = useSelector(
    (state) => state.sharedState.LetterReducer.tempLetterTableData
  );

  const extraState = useSelector(
    (state) => state.sharedState.LetterReducer.extraState
  );
  const createLetterDetail = useSelector(
    (state) => state?.sharedState?.LetterReducer?.createLetterDetail
  );
  const createLetterActive = useSelector(
    (state) => state.sharedState?.LetterReducer?.extraState?.createLetterActive
  );

  const [state, setState] = React.useState(
    searchTabData?.state
      ? searchTabData.state
      : {
          selectTypeCd: userDefaults?.defInvoiceSelectModeCd
            ? userDefaults?.defInvoiceSelectModeCd
            : defaultSelectBy,
          planType: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
          rebateProgram: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          allManufacturers: false,
          manufacturerSelected: {},
          templateType: 'All',
          templateName: 'All',
          invoiceNum: '',
        }
  );
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(
    searchTabData?.fullScreenView
  );
  const [fullScreenViewTableTwo, setFullScreenViewTableTwo] = React.useState(
    searchTabData?.fullScreenViewTableTwo
  );
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [templateTypeArray, setTemplateTypeArray] = React.useState([]);
  const [templateNameArray, setTemplateNameArray] = React.useState([]);
  const [templateListArray, setTemplateListArray] = React.useState([]);
  const [rebateProList, setRebateProList] = React.useState([]);
  const [selectManufacturer, setSelectManufacturer] = React.useState(
    mfgSelected || {}
  );
  const [gridApi, setGridApi] = React.useState();
  const gridRef = React.useRef();
  const [gridParams, setGridParams] = React.useState(null);
  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setCreateTemplateExtraState({
        ...extraState,
        ...val,
      })
    );
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      handleErrorMessages({
        ...errorMessagesFromRedux,
        ...val,
      })
    );
  };

  // Plan type useEffect
  React.useEffect(() => {
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue());
    }

    if (!templateTypeList?.TEMPLATE_TYPE_CD) {
      dispatch(getTemplateType());
    }
  }, []);

  // Dropdown values useEffect
  React.useEffect(() => {
    const planList =
      getPlanTypeData &&
      getPlanTypeData.PLAN_TYPE_CD &&
      getPlanTypeData.PLAN_TYPE_CD.length > 0 &&
      getPlanTypeData.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    setRadioList(planList);
  }, [getPlanTypeData]);

  // Plan type useEffect
  React.useEffect(() => {
    let data = [];
    if (tempLetterTableData && !_.isEmpty(tempLetterTableData)) {
      let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
      if (!_.isEmpty(localErr)) {
        localErr = _.filter(localErr, (l) => l.field !== 'resultNotFound');
      }
      let rebateArr = [];
      let errorPass = false;
      if (
        tempLetterTableData.message === 'SUCESS' &&
        tempLetterTableData.status === '001'
      ) {
        if (
          tempLetterTableData?.letterHeaderVOs &&
          !_.isEmpty(tempLetterTableData?.letterHeaderVOs)
        ) {
          data = tempLetterTableData?.letterHeaderVOs;
        } else {
          errorPass = true;
        }
      } else {
        errorPass = true;
      }
      if (errorPass) {
        rebateArr = localErr.filter((item) => item.field === 'rebateProgramCd');
        if (!(rebateArr?.length > 0)) {
          localErr.push({
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          });
        }
      }
      setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
    }
    setTemplateListArray(data);
  }, [tempLetterTableData]);

  React.useEffect(() => {
    let list = [];
    if (
      rebateProList?.status === STATUS_MSG &&
      rebateProList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProList.data)) {
        list = _.map(rebateProList.data, (val, ind) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProList]);

  React.useEffect(() => {
    let list = [];
    if (templateTypeList?.TEMPLATE_TYPE_CD) {
      if (!_.isEmpty(templateTypeList?.TEMPLATE_TYPE_CD)) {
        list = _.map(templateTypeList?.TEMPLATE_TYPE_CD, (val, ind) => ({
          ...val,
          id: val?.codeValueID?.codeValue,
          name: val?.codeValueID?.codeValue,
        }));
      }
    }
    setTemplateTypeArray(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [templateTypeList]);

  React.useEffect(() => {
    let list = [];

    if (!_.isEmpty(templateNameList)) {
      list = _.map(templateNameList, (val, ind) => ({
        ...val,
        id: val?.templateId,
        name: val?.name,
      }));
    }

    setTemplateNameArray(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [templateNameList]);

  // Calling API for Manufacturer List
  const getManufactureListData = () => {
    setSelectManufacturer('');
    // dispatch(setMfgSelected(''));
    dispatch(
      getManufacturerList({
        planType: state?.planType,
        mode: '1',
      })
    );
  };

  // dropdown list refresh case
  React.useEffect(() => {
    if (state.planType) {
      getCommonDropdownList(state.planType).then((res) =>
        setRebateProList(res)
      );
      getManufactureListData();
    }
  }, [state.planType]);

  React.useEffect(() => {
    if (state.selectTypeCd && state.planType) {
      getCommonDropdownList(state.planType ? state.planType : 'FD').then(
        (res) => setRebateProList(res)
      );
      getManufactureListData();
    }
  }, [state.selectTypeCd]);
  const onFirstDataRendered=(gridApi)=>{
 if (gridApi&&!mfgSelected?.mfgId) {
        gridApi.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
        const selectedRowNodes = gridApi.getSelectedNodes();
        let newData = [];
        if (!_.isEmpty(selectedRowNodes)) {
          newData = selectedRowNodes[0].data;
          onSelectManufacturer(selectedRowNodes[0]);
        }

        setSelectManufacturer(newData);
        dispatch(setMfgSelected(newData));
      }
}

  // set Manufacturer list
  React.useEffect(() => {
    setManufacturerList(fetchManufacturerList);
   
  }, [fetchManufacturerList]);

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/letter', true);
    } else {
      tabHighLigther('/letter', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'recipientId', sort: 'asc' }],
        });
      }
    }
  };

  // handing On change event on field level

  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    let bool = false;
    if (name === 'selectTypeCd' && value !== state.selectTypeCd) {
      dispatch(dispatchTempTableData([]));
      setSelectManufacturer('');
      dispatch(setMfgSelected(''));
      setManufacturerList([]);
      dispatch(dispatchManufacturerData([]));
      //setRebateProgramList([]);
      setTemplateNameArray([]);
      dispatch(dispatchTemplateNameList([]));
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      if (value === InvNumSelectBy) {
        const stateObjIn = {
          selectTypeCd: InvNumSelectBy,
          planType: state.planTypeCd,
          rebateProgram: '-1',
          allManufacturers: false,
          manufacturerSelected: {},
          templateType: 'All',
          templateName: 'All',
          invoiceNum: '',
        };
        setState(stateObjIn);
        dispatch(
          dispatchSearchTabData({
            fullScreenView: fullScreenView,
            fullScreenViewTableTwo: fullScreenViewTableTwo,
            state: stateObjIn,
          })
        );
      } else {
        const objPQM = {
          selectTypeCd: defaultSelectBy,
          planType: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
          rebateProgram: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          allManufacturers: false,
          manufacturerSelected: {},
          templateType: 'All',
          templateName: 'All',
          invoiceNum: '',
        };
        setState(objPQM);
        dispatch(
          dispatchSearchTabData({
            fullScreenView: fullScreenView,
            fullScreenViewTableTwo: fullScreenViewTableTwo,
            state: objPQM,
          })
        );
      }
    } else if (name === 'planType' && value !== state.planType) {
      dispatch(dispatchTempTableData([]));
      setState({ ...state, [name]: value, rebateProgram: '-1' });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value, rebateProgram: '-1' },
        })
      );
      bool = true;
      const tempArray = [];
      if (state.templateType === 'All') {
        templateTypeArray?.length > 0 &&
          templateTypeArray.forEach((item) => {
            tempArray.push(item.name);
          });
      } else {
        tempArray.push(state.templateType);
      }
      let obj = {
        rebateProgram: '-1',
        templateTypes: tempArray,
      };

      if (!state.allManufacturers && state.selectTypeCd !== InvNumSelectBy) {
        obj = { ...obj, mfgId: selectManufacturer?.mfgId };
      }

      if (state.selectTypeCd === InvNumSelectBy) {
        obj = { ...obj, invoiceNumber: state.invoiceNum };
      } else {
        obj = { ...obj, isSelectedByProQtrManu: true };
      }

      dispatch(getTempTableData(obj));
    } else if (name === 'rebateProgram') {
      dispatch(dispatchTempTableData([]));
      if (!value || value === '-1') {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');

        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
      setState({ ...state, [name]: value });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value },
        })
      );
      bool = true;
      const tempArray = [];
      if (state.templateType === 'All') {
        templateTypeArray?.length > 0 &&
          templateTypeArray.forEach((item) => {
            tempArray.push(item.name);
          });
      } else {
        tempArray.push(state.templateType);
      }
      let obj = {
        rebateProgram: value,
        templateTypes: tempArray,
      };

      if (!state.allManufacturers && state.selectTypeCd !== InvNumSelectBy) {
        obj = { ...obj, mfgId: selectManufacturer?.mfgId };
      }

      if (state.selectTypeCd === InvNumSelectBy) {
        obj = { ...obj, invoiceNumber: state.invoiceNum };
      } else {
        obj = { ...obj, isSelectedByProQtrManu: true };
      }

      dispatch(getTempTableData(obj));
    } else if (name === 'allManufacturers') {
      setState({ ...state, [name]: value });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value },
        })
      );
      bool = true;
      if (!value) {
        getManufactureListData();
      } else {
        handleTemplateTableData();
      }
    } else if (name === 'templateName') {
      dispatch(dispatchTempTableData([]));
      setState({ ...state, [name]: value });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value },
        })
      );
      bool = true;
      const tempArray = [];
      if (state?.templateType === 'All') {
        templateTypeArray?.length > 0 &&
          templateTypeArray.forEach((item) => {
            tempArray.push(item.name);
          });
      } else {
        tempArray.push(state?.templateType);
      }
      let obj = {
        rebateProgram: state?.rebateProgram,
        templateTypes: tempArray,
      };
      if (value !== 'All') {
        obj = { ...obj, templateId: value };
      }
      if (!state.allManufacturers && state.selectTypeCd !== InvNumSelectBy) {
        obj = { ...obj, mfgId: selectManufacturer?.mfgId };
      }

      if (state.selectTypeCd === InvNumSelectBy) {
        obj = { ...obj, invoiceNumber: state.invoiceNum };
      } else {
        obj = { ...obj, isSelectedByProQtrManu: true };
      }

      dispatch(getTempTableData(obj));
    } else if (name === 'templateType' && value !== state.templateType) {
      dispatch(dispatchTempTableData([]));
      setState({ ...state, [name]: value, templateName: 'All' });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value, templateName: 'All' },
        })
      );
      bool = true;
      const tempArray = [];
      if (value === 'All') {
        templateTypeArray?.length > 0 &&
          templateTypeArray.forEach((item) => {
            tempArray.push(item.name);
          });
      } else {
        tempArray.push(value);
      }
      let obj = {
        rebateProgram: state?.rebateProgram,
        templateTypes: tempArray,
      };

      if (!state.allManufacturers && state.selectTypeCd !== InvNumSelectBy) {
        obj = { ...obj, mfgId: selectManufacturer?.mfgId };
      }

      if (state.selectTypeCd === InvNumSelectBy) {
        obj = { ...obj, invoiceNumber: state.invoiceNum };
      } else {
        obj = { ...obj, isSelectedByProQtrManu: true };
      }

      dispatch(getTempTableData(obj));
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        dispatchSearchTabData({
          fullScreenView: fullScreenView,
          fullScreenViewTableTwo: fullScreenViewTableTwo,
          state: { ...state, [name]: value },
        })
      );
    }
    if (
      name === 'selectTypeCd' &&
      value === defaultSelectBy &&
      !fetchManufacturerList
    ) {
      getManufactureListData();
    }
    handleClearFilter();
    dispatch(dispatchFirstError(bool));
    setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
  };

  // handing full screen view for table one
  const handleFullScreenView = () => {
    dispatch(
      dispatchSearchTabData({
        fullScreenView: !fullScreenView,
        fullScreenViewTableTwo: fullScreenViewTableTwo,
        state: { ...state },
      })
    );
    setFullScreenView(!fullScreenView);
  };

  // handing full screen view for table two
  const handleFullScreenViewTableTwo = () => {
    dispatch(
      dispatchSearchTabData({
        fullScreenView: fullScreenView,
        fullScreenViewTableTwo: !fullScreenViewTableTwo,
        state: { ...state },
      })
    );
    setFullScreenViewTableTwo(!fullScreenViewTableTwo);
  };

  // handing by default row selection function
  const onGridReady = (params) => {
    if (params?.api) {
      setGridApi(params?.api);
    }

    if (mfgSelected?.mfgId) {
      if (params?.api) {
        params.api.forEachNode(
          (node) =>
            node?.data?.mfgId == mfgSelected?.mfgId && node?.setSelected(true)
        );
      }
    } else {
      params.api.forEachNode(
        (node) => node?.rowIndex == 0 && node?.setSelected(true)
      );
    }
    // const selectedRowNodes = params.api.getSelectedNodes();

    // onSelectManufacturer(selectedRowNodes[0]);
  };
  // handing select a manufacturer row
  const onSelectManufacturer = (e) => {
    setSelectManufacturer(e?.data);
    dispatch(setMfgSelected(e?.data));

    handleTemplateTableData(e?.data);
  };

  const handleTemplateTableData = (data) => {
    const tempArray = [];
    if (state?.templateType === 'All') {
      templateTypeArray?.length > 0 &&
        templateTypeArray.forEach((item) => {
          tempArray.push(item.name);
        });
    } else {
      tempArray.push(state?.templateType);
    }
    let obj = {
      rebateProgram: state?.rebateProgram,
      templateTypes: tempArray,
    };
    if (state.templateName !== 'All') {
      obj = { ...obj, templateId: state.templateName };
    }
    if (!state.allManufacturers && state.selectTypeCd !== InvNumSelectBy) {
      obj = { ...obj, mfgId: data?.mfgId };
    }

    if (state.selectTypeCd === InvNumSelectBy) {
      obj = { ...obj, invoiceNumber: state.invoiceNum };
    } else {
      obj = { ...obj, isSelectedByProQtrManu: true };
    }
    handleClearFilter();
    dispatch(getTempTableData(obj));
  };

  const handleTemplateNameList = (rebateProgVal) => {
    const tempArray = [];
    if (state?.templateType === 'All') {
      templateTypeArray?.length > 0 &&
        templateTypeArray.forEach((item) => {
          tempArray.push(item.name);
        });
    } else {
      tempArray.push(state?.templateType);
    }
    dispatch(
      getTemplateName({
        rebateProgramCd: rebateProgVal,
        templateTypeCd: tempArray,
      })
    );

    setState({ ...state, templateName: state.templateName || 'All' });
    dispatch(
      dispatchSearchTabData({
        fullScreenView: fullScreenView,
        fullScreenViewTableTwo: fullScreenViewTableTwo,
        state: { ...state, templateName: state.templateName || 'All' },
      })
    );
  };

  React.useEffect(() => {
    if (state.rebateProgram && templateTypeArray?.length > 0) {
      handleTemplateNameList(state.rebateProgram);
    }
  }, [state.rebateProgram, templateTypeArray, state.templateType]);

  const handleOnBlurEventOnFields = async (value, name) => {
    const localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (name === 'invoiceNum') {
      if (value) {
        const result = await dispatch(
          getRebateFromInvoice({ invoiceNum: value })
        );

        if (result?.data?.rebateProgramCd) {
          setState({ ...state, rebateProgram: result.data?.rebateProgramCd });
          dispatch(
            dispatchSearchTabData({
              fullScreenView: fullScreenView,
              fullScreenViewTableTwo: fullScreenViewTableTwo,
              state: { ...state, rebateProgram: result.data?.rebateProgramCd },
            })
          );
          const tempArray = [];
          if (state.templateType === 'All') {
            templateTypeArray?.length > 0 &&
              templateTypeArray.forEach((item) => {
                tempArray.push(item.name);
              });
          } else {
            tempArray.push(state.templateType);
          }
          let obj = {
            rebateProgram: result.data?.rebateProgramCd,
            templateTypes: tempArray,
          };

          if (
            !state.allManufacturers ||
            state.selectTypeCd !== InvNumSelectBy
          ) {
            obj = { ...obj, mfgId: selectManufacturer?.mfgId };
          }

          if (state.selectTypeCd === InvNumSelectBy) {
            obj = { ...obj, invoiceNumber: state.invoiceNum };
          } else {
            obj = { ...obj, isSelectedByProQtrManu: true };
          }

          dispatch(getTempTableData(obj));
        } else {
          dispatch(dispatchTempTableData([]));
          localErr.push({
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          });
        }
      }
    }

    setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // after click on create template and before redirect detail page
  React.useEffect(() => {
    if (createLetterActive && createLetterDetail) {
      let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
      if (!_.isEmpty(localErr)) {
        localErr = _.filter(localErr, (l) => l.field !== 'somethingWentWrong');
      }
      // let errorPass = true;
      if (!_.isEmpty(createLetterDetail)) {
        if (
          createLetterDetail.status === '001' &&
          createLetterDetail.message === 'SUCESS'
        ) {
          // dispatch(updateInvoiceDetailsByInvoiceNum([]));
          dispatch(updateCreateLetterSaveApi([]));
          setStateChange({
            createLetterActive: false,
          });
          dispatch(
            updateCreateLetterDetail({
              ...createLetterDetail.result,
            })
          );
          dispatch(updateCreateLetterDetailData([]));
          // errorPass = true;
          // setLoading(false);
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/displayLetterDetail',
            value: 'Display Letter Details',
            isFormDirty: false,
            isFormError: false,
            isFormSave: false,
            isRefresh: true,
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          history.push({ pathname: '/displayLetterDetail' });
          // } else {
          //   errorPass = false;
        } else {
          // errorPass = false
          localErr.push({
            field: 'somethingWentWrong',
            errorType: 'Something Went Wrong.',
            message: constantMessageData.FAIL_PROCESSING_REQUEST,
          });
        }
      }
      // if (!errorPass) {
      setErrorStateChange({ searchScreenErrors: localErr });
      // }
    }
  }, [createLetterActive, createLetterDetail]);

  // Redirect detail page with data
  const onClickForDetail = (val) => {
    const newData = { ...state };
    const request = {};

    if (val && !_.isEmpty(val)) {
      newData.selectedTemplate = val;
      newData.invoiceNum = val.invoiceNum;

      setStateChange({
        templateDetail: false,
        fetchMfg: true,
        edit: false,
        tabs: 'Body',
        templeType: null,
        letterAction: '',
        disabledBtn: false,
        saveApiActive: false,
        printPdf: false,
        saveEdit: false,
        createLetterActive: true,
      });

      request.templateId = val.templateId;
      request.templateVersion = val.templateVersion;
      request.letterId = val.letterId;

      // if (state?.selectTypeCd === defaultSelectBy) {
      //   request.mfgId = !_.isEmpty(mfgSelected) ? mfgSelected.mfgId : null;
      //   request.quarter = '1Q2022';
      //   request.rebateProgram = val.rebateProgramCd;
      // }
      // if (state?.selectTypeCd === InvNumSelectBy) {
      request.invoiceNumber = val?.invoiceNum;
      // }
      request.userId = logInUser;

      dispatch(
        getInvoiceDetailsByInvoiceNum({
          invoiceNum: request.invoiceNumber,
        })
      );

      dispatch(
        fetchCreateLetterDetailData({
          request: request,
          searchData: newData,
          headerDetail: {},
        })
      );
    }
  };

  const onGridReadySecond = (params) => {
    setGridParams(params);
  };
  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="cms-drug-file-search"
    >
      <CustomSeparator parent1="Display" parent2="Letter" />
      {!fullScreenView && !fullScreenViewTableTwo && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && !fullScreenViewTableTwo && (
        <>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-7 pr-2 mt-3 frr-letter-asterik-mandatory">
              <RadioGroupComponent
                data-testid="filter-plan-by-radio-btn-select-by-dfd"
                id="filter-plan-by-radio-btn-action"
                labelName={radioGroupLabelNameSelectedBy}
                required={true}
                optionList={[
                  {
                    name: 'Program, Manufacturer',
                    value: defaultSelectBy,
                  },
                  { name: 'Invoice Number', value: InvNumSelectBy },
                ]}
                defaultValue={state && state.selectTypeCd}
                filterAction={(e) => {
                  if (e !== defaultSelectBy) {
                    setSelectManufacturer({});
                    dispatch(setMfgSelected({}));
                  }
                  handleOnChangeEvent(e, 'selectTypeCd');
                }}
              />
            </div>

            {state && state?.selectTypeCd == defaultSelectBy ? (
              <div className="col-12 col-sm-6 col-md-6 col-lg-5  pr-2 mt-3 frr-two-col-radio frr-letter-asterik-mandatory">
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn"
                  id="filter-plan-by-radio-btn-action"
                  labelName={radioGroupLabelNamePlan}
                  required={true}
                  optionList={radioList}
                  defaultValue={state && state.planType}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'planType');
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
            ) : (
              <div className="mui-custom-form input-md col-3 pr-2 mt-3">
                <SelectBoxWithoutBoxComponent
                  id="invoice_number"
                  data-testid="invoice_number"
                  className="mt-2 mandate-fields"
                  label="Invoice Number"
                  labelName="Invoice Number"
                  required
                  selectedOne={false}
                  inputProps={{ maxLength: 38 }}
                  defaultValue={state?.invoiceNum}
                  filterAction={(e) => {
                    const rg = /^[0-9]*$/;
                    if (rg.test(e) && e?.length < 39) {
                      handleOnChangeEvent(e, 'invoiceNum');
                    }
                  }}
                  onBlurAction={(e) => {
                    const rg = /^[0-9]*$/;
                    if (rg.test(e)) {
                      handleOnBlurEventOnFields(e, 'invoiceNum');
                    }
                  }}
                  isError={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0 &&
                    errorMessagesFromRedux?.searchScreenErrors?.filter((x) => {
                      return x.field === 'invoiceNum';
                    }).length > 0
                      ? [
                          ...new Set(
                            errorMessagesFromRedux?.searchScreenErrors
                              ?.filter((x) => {
                                return x.field === 'invoiceNum';
                              })
                              .map((item) => {
                                return item.message;
                              })
                          ),
                        ]
                      : false
                  }
                />
                {/* <TextField
                  className="mandate-fields"
                  id="invoice_number"
                  data-testid="invoice_number"
                  label="Invoice Number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  inputProps={{ maxLength: 38 }}
                  value={state?.invoiceNum}
                  type="number"
                  onChange={(e) => {
                    if (e?.target?.value?.length < 39) {
                      handleOnChangeEvent(e.target.value, 'invoiceNum');
                    }
                  }}
                  onBlur={(e) =>
                    handleOnBlurEventOnFields(e.target.value, 'invoiceNum')
                  }
                  helperText={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0
                      ? [
                          ...new Set(
                            errorMessagesFromRedux?.searchScreenErrors
                              ?.filter((x) => {
                                return x.field === 'invoiceNum';
                              })
                              .map((item) => {
                                return item.message;
                              })
                          ),
                        ]
                      : null
                  }
                  error={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0 &&
                    errorMessagesFromRedux?.searchScreenErrors?.filter((x) => {
                      return x.field === 'invoiceNum';
                    }).length > 0
                      ? [
                          ...new Set(
                            errorMessagesFromRedux?.searchScreenErrors
                              ?.filter((x) => {
                                return x.field === 'invoiceNum';
                              })
                              .map((item) => {
                                return item.message;
                              })
                          ),
                        ]
                      : false
                  }
                /> */}
              </div>
            )}
          </div>
          {state && state?.selectTypeCd == defaultSelectBy && (
            <div className="">
              <div>
                <CheckBoxComponent
                  labelName="All Manufacturers"
                  defaultValue={state && state.allManufacturers}
                  data-testid="allmanufacturercheck"
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'allManufacturers');
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
      <div>
        {state &&
        state.selectTypeCd === defaultSelectBy &&
        !state.allManufacturers &&
        // manufacturerList?.length > 0 &&
        !fullScreenViewTableTwo ? (
          <>
            <TableGrid
              gridCall={onGridReady}
              gridDataRendered={onFirstDataRendered}
              data-testid="manufacturer-dl-table"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={manufacturerList}
              columnDefs={TableHeaderForManufacturer}
              onSelect={(e) => {
                dispatch(dispatchFirstError(true));
                onSelectManufacturer(e);
              }}
              exportFile
              animateRows
              isScrollOn
              sideBar={false}
              fileName="Display Letter-Manufacturer"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              // suppressCellFocus
              onCellFocused={onCellFocused}
            />
          </>
        ) : null}
      </div>
      {!fullScreenView && !fullScreenViewTableTwo && (
        <div className="row">
          {state && state?.selectTypeCd === defaultSelectBy && (
            <div className="col-12 col-sm-3">
              <div className="mt-2">
                <legend aria-hidden="true" className="d-none" />
                <div className=" my-2">
                  <div className="mui-custom-form with-select ">
                    <TextField
                      data-testid="rebate_program-dl"
                      id="rebate_program"
                      label={rebateProgramLabelName}
                      fullWidth
                      className={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux?.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields'
                                  : null
                            )
                          : null
                      }
                      select
                      required
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      error={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux?.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnBlurEventOnFields(e.target.value, 'rebate')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={state && state?.rebateProgram}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'rebateProgram');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item, key) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-12 col-sm-3">
            <div className="mt-2">
              <div className=" my-2">
                <div className="mui-custom-form with-select ">
                  <TextField
                    data-testid="template-type-dl"
                    id="template-type"
                    label="Template Type"
                    fullWidth
                    className={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field == 'template_type' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    required
                    select
                    placeholder=""
                    error={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field == 'template_type' ? l.message : null
                          )
                        : null
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ id: 'template-type' }}
                    value={state && state?.templateType}
                    onChange={(e) => {
                      handleOnChangeEvent(e.target.value, 'templateType');
                    }}
                  >
                    <MenuItem selected key="All" value="All">
                      All
                    </MenuItem>
                    {templateTypeArray &&
                    templateTypeArray.length &&
                    templateTypeArray.length > 0
                      ? templateTypeArray.map((item, key) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <div className="mt-2">
              <legend aria-hidden="true" className="d-none" />
              <div className=" my-2">
                <div className="mui-custom-form with-select ">
                  <TextField
                    data-testid="template-name-dl"
                    id="template-name"
                    label="Template Name"
                    fullWidth
                    className={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field == 'template_name' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    required
                    select
                    placeholder=""
                    error={
                      errorMessagesFromRedux?.length > 0
                        ? _.map(errorMessagesFromRedux, (l) =>
                            l.field == 'template_name' ? l.message : null
                          )
                        : null
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ id: 'template-name' }}
                    value={state && state?.templateName}
                    onChange={(e) => {
                      handleOnChangeEvent(e.target.value, 'templateName');
                    }}
                  >
                    <MenuItem selected key="All" value="All">
                      All
                    </MenuItem>
                    {templateNameArray &&
                    templateNameArray.length &&
                    templateNameArray.length > 0
                      ? templateNameArray.map((item, key) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!fullScreenView && (
        <TableGrid
          ref={gridRef}
          gridCall={onGridReadySecond}
          data-testid="template-dl-table"
          rowSelection="single"
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenViewTableTwo}
          handleFullScreenViewClick={handleFullScreenViewTableTwo}
          gridHeight={fullScreenViewTableTwo ? '70vh' : viewPortHeight_355}
          rowData={templateListArray || []}
          columnDefs={TableHeaderForTempLetter}
          cellClickedListener={(e) => {
            onClickForDetail(e.data);
          }}
          frameworkComponents={{
            TemplateNameRenderer: (cellInfo) => {
              if (
                cellInfo.value !== null &&
                cellInfo.value !== '' &&
                cellInfo?.value?.length > 20
              ) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="labeler-tooltip">{cellInfo?.value}</Tooltip>
                    }
                  >
                    <div>
                      {cellInfo?.value &&
                        `${cellInfo?.value.substring(0, 20)}...`}
                    </div>
                  </OverlayTrigger>
                );
              }
              return <div>{cellInfo.value}</div>;
            },
            MediaTypeRenderer: (cellInfo) => {
              if (
                cellInfo.value !== null &&
                cellInfo.value !== '' &&
                cellInfo?.value?.length > 20
              ) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="labeler-tooltip">{cellInfo?.value}</Tooltip>
                    }
                  >
                    <div>
                      {cellInfo?.value &&
                        `${cellInfo?.value.substring(0, 20)}...`}
                    </div>
                  </OverlayTrigger>
                );
              }
              return <div>{cellInfo.value}</div>;
            },
          }}
          exportFile
          animateRows
          sideBar={false}
          fileName="Display Letter-Template"
          singleClickEdit
          suppressCellFocus
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          onCellFocused={onCellFocused}
        />
      )}
    </div>
  );
};
export default DisplayLetterSearch;
